import { Button } from '@heroui/react';
import { getButtonVariantColors } from '../../theme/colors';
import { CustomHeroButtonProps } from './types';

const CustomHeroButton: React.FC<CustomHeroButtonProps> = ({
  title,
  onPress,
  className = '',
  size = 'md',
  isLoading = false,
  disabled = false,
  startContent,
  endContent,
  variant = 'primary',
  customStyles = {},
}) => {
  const variantColors = getButtonVariantColors(variant);

  return (
    <Button
      size={size}
      isLoading={isLoading}
      disabled={disabled}
      onPress={onPress}
      startContent={startContent}
      endContent={endContent}
      className={`
        h-10 leading-5 font-semibold rounded-3 !text-sm px-4 py-2.5
        disabled:cursor-not-allowed disabled:opacity-50
        ${className}
      `}
      style={{
        backgroundColor: variantColors.background,
        color: variantColors.text,
        ...(disabled && {
          backgroundColor: variantColors.disabled.background,
          color: variantColors.disabled.text,
          opacity: variantColors.disabled.opacity,
        }),
        ...customStyles,
      }}
    >
      {title}
    </Button>
  );
};

export default CustomHeroButton;
